import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {CompanyModel} from "../../shared/models/company.model";
import { MaterialModule } from 'src/app/app.materials';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-info-block',
  templateUrl: './info-block.component.html',
  styleUrls: ['./info-block.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MaterialModule, CommonModule]
})
export class InfoBlockComponent implements OnInit {
  @Input() list: any[] = [];
  @Input() overview: any[] = [];
  @Input() company: CompanyModel = null;
  @Input() employeeNum = '-';
  @Input() isData: any = null;

  constructor() { }

  ngOnInit(): void {
  }

}
